import { $BaseCabinet, $Cabinet, $Countertop, $TallCabinet, $WallCabinet } from '../__generated/enhanced-model.js';
import { TallCabinet, WallCabinet } from '../__generated/model/index.js';
// No cabinet to the left of the current cabinet
const isLeftCabinet = (cabinets, cabinet)=>{
    return cabinets.every((c)=>c.offsetX + c.$width !== cabinet.offsetX);
};
// No cabinet to the right of the current cabinet
const isRightCabinet = (cabinets, cabinet)=>{
    return cabinets.every((c)=>cabinet.offsetX + cabinet.$width !== c.offsetX);
};
const getProductSuffix = (cabinets, c)=>{
    const relevantCabinets = TallCabinet.is(c) || WallCabinet.is(c) ? cabinets.filter((c)=>TallCabinet.is(c) || WallCabinet.is(c)) : cabinets.filter((c)=>!WallCabinet.is(c));
    const left = isLeftCabinet(relevantCabinets, c);
    const right = isRightCabinet(relevantCabinets, c);
    if (left && right) {
        return '-B';
    }
    if (left) {
        return '-L';
    }
    if (right) {
        return '-R';
    }
    return '';
};
const generateProductCode = (cabinets, c)=>c.$productCode + getProductSuffix(cabinets, c);
const getPrice = (segment, width, segmentPrices)=>{
    if (segmentPrices) {
        const materialType = segment.$material === segment.$defaultMaterialName ? 'economy' : 'textured';
        const match = segmentPrices.find((p)=>p.productCode === segment.$productCode && p.width === width && p.materialType === materialType);
        return match?.price ?? 0;
    }
    return 0;
};
export const generateBom = (segments, segmentPrices, includeCountertop)=>{
    const allCabinets = segments.filter((s)=>$Cabinet.is(s));
    const tallCabinets = segments.filter((s)=>$TallCabinet.is(s) || $WallCabinet.is(s));
    const baseCabinets = allCabinets.filter((s)=>$BaseCabinet.is(s));
    const countertopsSortedByOffsetX = includeCountertop ? segments.filter((s)=>$Countertop.is(s)).sort((a, b)=>a.offsetX - b.offsetX) : [];
    const continguousCountertops = countertopsSortedByOffsetX.reduce((acc, countertop)=>{
        const previous = acc.length > 0 ? acc[acc.length - 1] : null;
        if (!previous || countertop.offsetX !== previous.countertop.offsetX + previous.width) {
            acc.push({
                countertop,
                width: countertop.$width
            });
        } else if (previous) {
            previous.width += countertop.$width;
        }
        return acc;
    }, []);
    return [
        ...tallCabinets.map((segment)=>({
                segment,
                productCode: generateProductCode(tallCabinets, segment),
                width: segment.$width,
                price: getPrice(segment, segment.$width, segmentPrices)
            })),
        ...baseCabinets.map((segment)=>({
                segment,
                productCode: generateProductCode(allCabinets, segment),
                width: segment.$width,
                price: getPrice(segment, segment.$width, segmentPrices)
            })),
        ...continguousCountertops.map((c)=>({
                segment: c.countertop,
                productCode: `${c.countertop.$productCode}-${c.width}`,
                width: c.width,
                price: getPrice(c.countertop, c.width, segmentPrices)
            }))
    ];
};

//# sourceMappingURL=bom-generator.js.map